import i18nFactory from '@yandex-int/i18n';

import { Shape2Icon, Shape2Tone } from '../../components/Shape2/Shape2';
import { getPricePackagesFilterCriteria } from '../../declarations/filter/filter';
import { DealsSourceParams } from '../../typings/deals';
import { FilterPartialExpression } from '../../typings/filter';
import { GdStatusApprove } from '../../typings/graphql-grid';
import { SortDirection, SortParams } from '../../typings/grid';
import { PricePackageId } from '../../typings/pricePackages';
import { castStringToEnum } from '../CastHelpers';
import { parseFilterFromString } from '../FilterHelpers/FilterHelpers';

import * as keyset from './PricePackagesHelpers.i18n';

const i18n = i18nFactory(keyset);

export interface NormalizeDealsSourceParamsData {
    sortKey?: string;
    sortDirection?: string;
    login: string;
    filter?: string;
    noStats?: string;
}

export class PricePackagesHelpers {
    public static getPricePackageEditPageItemEditorId(id: PricePackageId): string {
        return `package-${id}`;
    }

    public static getPricePackageStatusText(status: GdStatusApprove): string {
        switch (status) {
            case GdStatusApprove.NEW:
                return i18n('status-new');
            case GdStatusApprove.NO:
                return i18n('status-no');
            case GdStatusApprove.WAITING:
                return i18n('status-waiting');
            case GdStatusApprove.YES:
                return i18n('status-yes');
            default:
                return i18n('status-new');
        }
    }

    public static getPricePackageStatusIcon(
        status: GdStatusApprove
    ): {
        icon: Shape2Icon;
        tone: Shape2Tone;
    } {
        let statusIcon = {
            icon: Shape2Icon.draft,
            tone: Shape2Tone.dark
        };

        switch (status) {
            case GdStatusApprove.NEW:
                statusIcon = {
                    icon: Shape2Icon.draft,
                    tone: Shape2Tone.dark
                };
                break;
            case GdStatusApprove.NO:
                statusIcon = {
                    icon: Shape2Icon.reject,
                    tone: Shape2Tone.red
                };
                break;
            case GdStatusApprove.WAITING:
                statusIcon = {
                    icon: Shape2Icon.time,
                    tone: Shape2Tone.dark
                };
                break;
            case GdStatusApprove.YES:
                statusIcon = {
                    icon: Shape2Icon.statusRunning,
                    tone: Shape2Tone.dark
                };
                break;
            default:
                statusIcon = {
                    icon: Shape2Icon.draft,
                    tone: Shape2Tone.dark
                };
                break;
        }

        return statusIcon;
    }

    public static normalizeSourceParams({
        sortKey,
        sortDirection,
        login,
        filter,
        noStats
    }: NormalizeDealsSourceParamsData): DealsSourceParams {
        return {
            login,
            sortParams: this.normalizeSortParams(sortKey, sortDirection),
            filter: filter ? this.normalizeFilter(filter) : undefined,
            noStats: noStats || undefined
        };
    }

    private static normalizeFilter(filterString: string): FilterPartialExpression[] {
        const criteria = getPricePackagesFilterCriteria();

        return parseFilterFromString(criteria, filterString, true);
    }

    private static normalizeSortParams(sortKey?: string, sortDirection?: string): SortParams {
        let sortParams: SortParams;

        const defaults = {
            key: 'name',
            direction: SortDirection.asc
        };

        if (sortKey) {
            sortParams = {
                key: sortKey,
                direction: sortDirection ? castStringToEnum(sortDirection, SortDirection) : SortDirection.desc
            };
        } else {
            sortParams = defaults;
        }

        return sortParams;
    }
}
